import {Http} from '../dimijs/src/lib/sources/http';
import {ICrudFilter, ICrudList, ICrudPagination, ICrudSorting} from '../dimijs/src/lib/sources/source';
import {IPlaylistTrack} from './types';

export const getPlaylistTracksSource = (store: any, serialized?: {
    data: ICrudList<any>,
    filter: ICrudFilter<any>[],
    pagination: ICrudPagination,
    sorting?: ICrudSorting<any>[]
  }) => {
  if (serialized) {
    store.playlistTracksSource.source.addSerializedState(serialized.data,
      serialized.filter, serialized.pagination, serialized.sorting);
  }
  return store.playlistTracksSource as {
    inited: boolean,
    source: Http<IPlaylistTrack, string>,
    playlistTracksSorting: ICrudSorting<IPlaylistTrack>[],
    playlistTracksFilter: ICrudFilter<IPlaylistTrack>[],
    playlistTracksPagination: ICrudPagination,
  };
};

export const initPlaylistTracksSource = (store: any, initProps: any) => {
  store.playlistTracksSource = {
    inited: false,
    source: null as any,
    playlistTracksSorting: [],
    playlistTracksFilter: [],
    playlistTracksPagination: {page: 0, countOnPage: 100},
  };
  store.playlistTracksSource.source = new Http<IPlaylistTrack, string>('_id',
    // @ts-ignore
    initProps && initProps.playlist_tracks ? {
      data: {
        // @ts-ignore
        data: initProps.playlist_tracks,
      },
      filter: store.playlistTracksSource.playlistTracksFilter,
      pagination: store.playlistTracksSource.playlistTracksPagination,
      sorting: store.playlistTracksSource.playlistTracksSorting,
    } : undefined);
  store.playlistTracksSource.source.httpEndPoint = '/api/collections/playlist_tracks';
};
